import { EmailEngagement } from '@/components/admin/analyticsV2/emailEngagement';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(EmailEngagement, {
  requiresEvery: [RouteRestrictions.ADMIN_ROLE],
});
